import { Flex, Group, Paper, Stack, Text } from "@mantine/core";
import { useSessionStore } from "../../../../../stores/UserStore";
import AddExternalKey from "./AddExternalKey";
import ExternalAPIListing from "./ExternalAPIListing";
import kaspr_logo from "../../../../../assets/logos/kaspr.png";
import chatgpt_logo from "../../../../../assets/logos/chatgpt.svg";
import { useState } from "react";
import { useLanguage } from "../../../../../stores/LanguageStore";

const Integration = () => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(true);

  return (
    <>
      <Paper component={Group} p={"lg"} mt={16}>
        <Stack w={"50%"}>
          <Group>
            <Text fw={600} size="lg">
              {lang.settings.int_title}{" "}
              {useSessionStore.getState().reseller?.name}
            </Text>
            <Flex w={25}>
              <img src={kaspr_logo} style={{ width: "100%" }} />
            </Flex>
            <Flex w={25}>
              <img src={chatgpt_logo} style={{ width: "100%" }} />
            </Flex>
          </Group>

          <Text>
            {lang.settings.int_text.replace(
              "#",
              useSessionStore.getState()?.reseller?.name || "Magileads"
            )}
          </Text>
        </Stack>
        <AddExternalKey onFinish={() => setLoading(true)} ml="auto" />
      </Paper>

      <Text fw={600} size="lg" mt={32}>
        {lang.settings.your_int}
      </Text>

      <Flex flex={1} pos={"relative"}>
        <ExternalAPIListing loading={loading} setLoading={setLoading} />
      </Flex>
    </>
  );
};

export default Integration;
